import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AlertController, PopoverController, ActionSheetController, LoadingController, Platform, NavController, ModalController } from '@ionic/angular';
import { ReportDynamicParametersModel } from 'app/models/dms/reportParameter.model';
import { ReportSpecModel } from 'app/models/dms/reportSpec.model';
import { GeneralService } from 'app/services/general.service';
import { ReportService } from 'app/services/report.service';
import { StorageService } from 'app/services/storage.service';
import { UserService } from 'app/services/user.service';
import { Constants } from 'app/utility/constants';
import { MotorcentralEdition } from 'app/utility/enums';
import { timeout } from 'rxjs';
import { EditorPageComponent } from '../editor-page/editor-page.component';
import { TaskService } from 'app/services/task.service';
import { TabModel } from 'app/models/shared/tab.model';

@Component({
  selector: 'app-report-dynamic-params',
  templateUrl: './report-dynamic-params.component.html',
  styleUrls: ['./report-dynamic-params.component.scss'],
  standalone: false
})
export class ReportDynamicParamsComponent  extends EditorPageComponent implements OnInit
{
    @Input() reportSpecId: string;
    @Input() existingReportSpec: ReportSpecModel = null;
    @Input() existingReportParamTabs: TabModel[] = [];
    @Input() action: EventEmitter<string>;


    public reportSpec: ReportSpecModel;

    showLoading: boolean = true;
    isExpress: boolean = false;

    constructor(
        public reportService: ReportService,
        public generalService: GeneralService, //for lookups - todo: remove
        public userService: UserService,
        public route: ActivatedRoute,
        public titleService: Title,
        public storage: StorageService,
        public alertController: AlertController,
        public popoverController: PopoverController,
        public actionSheetController: ActionSheetController,
        public loadingController: LoadingController,
        protected cd: ChangeDetectorRef,
        public platform: Platform,
        public navCtrl: NavController,
        public modalController: ModalController,
        public taskService: TaskService
    )
    {
        super(userService, route, titleService, storage, alertController, popoverController, actionSheetController, loadingController, cd, platform);
        this.editActive = true;
    }
    mcOnInit()
    {
        this.activeSegment = 'general';
        this.setupTitle();
        this.userService.getLicence()
            .subscribe({
                next: async license =>
                {
                    this.isExpress = (license.motorcentralEdition == MotorcentralEdition.Express);
                },
                error: err =>
                {
                    this.handleError(err);
                }
            });
    }

    mcViewDidEnter()
    {
        this.activeSegment = "general";
    }

    public getHeadingTitle(): string
    {
        if (this.reportSpec && this.reportSpec.name)
        {
            return this.reportSpec.name;
        }
        else
        {
            return "Report";
        }
    }

    public getPageName(): string
    {
        return "Report";
    }


    mcOnDestroy()
    {

    }

    public fetchTemplate()
    {

    }

    editLaunched: boolean = false;
    public async fetchObject(clearCache: boolean = false)
    {
        if (this.existingReportParamTabs && this.existingReportParamTabs.length > 0)
        {
            this.reportSpec = this.existingReportSpec;
            this.fieldGroupTabs = this.existingReportParamTabs;
            this.setupTitle();
            this.skeleton = false;
            this.showLoading = false;
        }
        else if (this.existingReportSpec && !clearCache)
        {
            this.reportSpec = this.existingReportSpec;
            this.id = this.reportSpecId;
            this.setupTitle();
            this.setupFieldGroups();
        }
        else
        {
            this.setEdit(true);
            this.id = this.reportSpecId;
            this.showLoading = true;
            this.subscription = this.reportService.getCachedReportDynamicSpec(this.id, clearCache)
                .pipe(timeout(Constants.ApiShortTimeout))
                .subscribe
                ({
                    next: async x =>
                    {
                        this.reportSpec = x;
                        if (!clearCache)
                        {
                            const lastReport = await this.storage.get(Constants.IonicStorage_DynamicReportSpec + '-' + this.id);
                            if (lastReport)
                            {
                                this.reportSpec = JSON.parse(lastReport);
                            }
                        }
                        else
                        {
                            await this.storage.set(Constants.IonicStorage_DynamicReportSpec + '-' + this.id, JSON.stringify(this.reportSpec));
                        }
                        this.setupTitle();
                        this.setupFieldGroups();
                    },
                    error: err =>
                    {
                        this.showLoading = false;
                        this.skeleton = false;
                        this.handleError(err);
                    }
                });
        }
    }

    paramPayload: ReportDynamicParametersModel = new ReportDynamicParametersModel();
    async launchPdf()
    {
        if (this.userService.mcMinVersion("3.2.24") && this.existingReportParamTabs && this.existingReportParamTabs.length > 0)
        {
            this.action.emit('closePdf');
        }

        this.paramPayload.reportSpecId = this.reportSpec.reportSpecId;
        this.paramPayload.parameters = [];

        for (let fieldGroupTab of this.fieldGroupTabs)
        {
            for (let fieldGroup of fieldGroupTab.fieldGroups)
            {
                for (let field of fieldGroup.fields)
                {
                    field.id = field.id && field.id.length > 0 ? field.id.charAt(0).toUpperCase() + field.id.slice(1) : field.id;

                    //find the item in the param sets
                    let paramSet = this.reportSpec.reportParamSets.find(x => x.reference == field.id);

                    paramSet.reportParamValue = field.value || null;

                    let existing = this.paramPayload.parameters.find(x => x.reference == paramSet.reference);
                    if (!existing)
                    {
                        this.paramPayload.parameters.push(paramSet);
                    }
                }
            }
        }

        this.taskService.markDynamicReportViewed();
        this.storage.remove(Constants.IonicStorage_DynamicReportScheduledTaskId);

        await this.storage.set(Constants.IonicStorage_DynamicReportSpec + "-" + this.reportSpec.reportSpecId, JSON.stringify(this.reportSpec));

        const loading = await this.loadingController.create({
            message: 'Generating Report',
            duration: 60000
        });
        await loading.present();

        this.reportService.runReport(this.paramPayload)
            .subscribe({
                next: taskId =>
                {
                    setTimeout(() =>
                    {
                        loading.dismiss();
                        this.storage.set(Constants.IonicStorage_DynamicReportScheduledTaskId, taskId);
                        this.dismissTheModal(true, taskId);
                    }, 1000);
                },
                error: error =>
                {
                    loading.dismiss();
                    this.handleError(error);
                }
            });
    }


    public async setupFieldGroups(makeDirty: boolean = false): Promise<void>
    {
        this.fieldGroupTabs = await this.reportService.setupFieldGroups(this.reportSpec, this.isExpress, true, this.editActive, makeDirty);
        this.skeleton = false;
        this.showLoading = false;
    }


    public handleFieldClicked(ev: any)
    {
        if (!(ev.detail)) return;

        switch (ev.detail.id)
        {
            
        }

    }

    public handleFieldChangedAdditional(ev: any): void
    {
        if (!(ev.detail)) return;

        switch (ev.detail.id)
        {
            
        }
    }

    async cancelModal()
	{
		// console.log('cancelModal', this.isDirty);
		if (this.isDirty)
		{
			//prompt user to save
			const alert = await this.alertController.create({
				header: "Unsaved Changes",
				message: "Some data has changed. Do you want to close without saving?",
				buttons: [
					{
						text: 'Cancel',
						role: 'cancel',
						cssClass: 'primary',
						handler: () =>
						{
							//do nothing
							return;
						}
					},
					{
						text: 'OK',
						cssClass: 'danger',
						handler: () =>
						{
							this.dismissTheModal(false);
						}
					}
				]
			});

			await alert.present();
		}
		else
		{
			this.dismissTheModal(false);
		}
	}

    async dismissTheModal(save: boolean, taskId: string = null)
	{
		// console.log('dismissTheModal', save);
		// Dismiss the top modal returning some data object
		if (save && taskId != null)
        {
            this.modalController.dismiss({
                'result': {
                    save: save,
                    taskId: taskId,
                    report: this.reportSpec,
                    params: this.paramPayload
                }
            });
        }
        else
        {
            this.modalController.dismiss({
                'result': {
                    save: false
                }
            });
        }
	}

    async doRefresh(ev: any)
	{
		setTimeout(() =>
		{
			this.fetchObject(true);
			ev.target.complete();
		}, 250);
	}

    

}
